export const getPrependFromPublicUrl = (url) => {
  if (!url) return 'ramblas.io/locations/';
  const parts = url.split('/locations/');
  return `${parts[0].replace(/^https?:\/\//, '')}/locations/`;
};
